import { gql } from "@/gql";

/**
 * Execute an agent intent
 * Performs the actual mutation based on the intent's actionType (e.g., MANAGE_SERVICE)
 */
export const EXECUTE_AGENT_INTENT_MUTATION = gql(`
  mutation ExecuteAgentIntent($intentId: ID!, $salonId: ID!) {
    executeAgentIntent(intentId: $intentId, salonId: $salonId) {
      id
      salonId
      threadId
      actionType
      status
      payload
      executedAt
      executedByUserId
      rejectedAt
      rejectedByUserId
      failureReason
      createdAt
      updatedAt
    }
  }
`);

/**
 * Reject an agent intent
 * Marks an intent as rejected with optional reason
 */
export const REJECT_AGENT_INTENT_MUTATION = gql(`
  mutation RejectAgentIntent($intentId: ID!, $salonId: ID!, $reason: String) {
    rejectAgentIntent(intentId: $intentId, salonId: $salonId, reason: $reason) {
      id
      salonId
      threadId
      actionType
      status
      payload
      executedAt
      executedByUserId
      rejectedAt
      rejectedByUserId
      failureReason
      createdAt
      updatedAt
    }
  }
`);

/**
 * Get thread intents
 * Retrieves all intents for a given thread with optional status filter
 */
export const GET_THREAD_INTENTS_QUERY = gql(`
  query GetThreadIntents($threadId: ID!, $salonId: ID!, $status: AgentIntentStatus) {
    getThreadIntents(threadId: $threadId, salonId: $salonId, status: $status) {
      id
      salonId
      threadId
      actionType
      status
      payload
      executedAt
      executedByUserId
      rejectedAt
      rejectedByUserId
      failureReason
      createdAt
      updatedAt
    }
  }
`);
